import React, { useContext, useState } from 'react'
import { ButtonCreate, Container, FormDiv, HeaderText, Input, InputDiv, Label } from './style'
import axios from 'axios'
import { FeedbackContext } from '../../contexts/FeedbackContext'

const CreateOrdenoCustomer = () => {
  const { setFeedback } = useContext(FeedbackContext)
  const [formData, setFormData] = useState({
    companyName: '',
    segment: '',
    cnpj: '',
    // name: '',
    // email: '',
    // phone: '',
    // password: '',
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleCreate = () => {
    axios.post(`${process.env.REACT_APP_STEEL_ORDERS_BASE_URL}/tenant`, formData)
      .then(response => {
        if (response.data) {
          setFeedback({
            isOpen: true,
            message: 'Cliente cadastrado com sucesso',
            statusOk: true
          })
        }
      })
      .catch(error => {
        setFeedback({
          isOpen: true,
          message: 'Erro ao cadastrar cliente',
          statusOk: false
        })
      })
  }
  
  return (
    <Container>
      <FormDiv>
        <HeaderText>Cadastrar cliente Ordeno</HeaderText>
        <InputDiv>
          <Label>Empresa</Label>
          <Input value={formData.companyName} onChange={handleChange} name="companyName"/>
        </InputDiv>
        <InputDiv>
          <Label>Segmento</Label>
          <Input value={formData.segment} onChange={handleChange} name="segment"/>
        </InputDiv>
        <InputDiv>
          <Label>CNPJ</Label>
          <Input value={formData.cnpj} onChange={handleChange} name="cnpj"/>
        </InputDiv>
        {/* <InputDiv>
          <Label>Nome</Label>
          <Input value={formData.name} onChange={handleChange} name="name"/>
        </InputDiv>
        <InputDiv>
          <Label>E-mail</Label>
          <Input value={formData.email} onChange={handleChange} name="email"/>
        </InputDiv>
        <InputDiv>
          <Label>Telefone</Label>
          <Input value={formData.phone} onChange={handleChange} name="phone"/>
        </InputDiv>
        <InputDiv>
          <Label>Senha de acesso</Label>
          <Input value={formData.password} onChange={handleChange} name="password" type="password" />
        </InputDiv> */}
      </FormDiv>
      <ButtonCreate onClick={handleCreate}>Criar</ButtonCreate>
    </Container>
  )
}

export default CreateOrdenoCustomer